const f = {
  contrastText: "#000",
  dark: "#f6f",
  light: "#f6f",
  lighter: "#f9f",
  lightest: "#fcf",
  main: "#f0f"
};
var a = /* @__PURE__ */ ((r) => (r.Dye = "dye", r.Normal = "normal", r))(a || {}), e = /* @__PURE__ */ ((r) => (r.Encore = "encore", r.Jade = "jade", r))(e || {});
export {
  a as M,
  e as T,
  f as d
};
//# sourceMappingURL=constants-CnFYFetN.mjs.map
